<template>
    <svg
        width="672"
        height="378"
        viewBox="0 0 672 378"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <text
            x="41"
            y="54"
            font-family="Inter"
            font-weight="700"
            font-size="34"
            fill="var(--et-colors-text)"
        >
            FAQs
        </text>
        <text
            x="8"
            y="90"
            font-family="Inter"
            font-weight="500"
            font-size="15"
            fill="var(--et-colors-text)"
            fill-opacity="0.8"
        >
            Can not find answer?
        </text>
        <text
            x="42"
            y="112"
            font-family="Inter"
            font-weight="500"
            font-size="15"
            fill="var(--et-colors-text)"
            fill-opacity="0.8"
        >
            Contact us
        </text>

        <path
            d="M44.665 116.75H115.331V117.45H44.665V116.75Z"
            fill="var(--et-colors-text)"
            fill-opacity="0.8"
        />
        <g>
            <g clip-path="url(#clip0_414_3446)">
                <rect
                    x="184"
                    y="6"
                    width="476"
                    height="351.5"
                    rx="12"
                    fill="var(--et-colors-card-background)"
                />
                <text
                    x="208"
                    y="46"
                    font-family="Inter"
                    font-weight="600"
                    font-size="14"
                    fill="var(--et-colors-card-text)"
                >
                    Will I receive a VAT invoice?
                </text>

                <path
                    d="M630 45L624 39L618 45"
                    stroke="#667085"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <rect
                    x="208"
                    y="65.7856"
                    width="380"
                    height="12"
                    rx="6"
                    fill="var(--et-colors-card-text)"
                    fill-opacity="0.15"
                />
                <rect
                    x="208"
                    y="85.6428"
                    width="298"
                    height="12"
                    rx="6"
                    fill="var(--et-colors-card-text)"
                    fill-opacity="0.15"
                />
                <rect
                    x="208"
                    y="105.5"
                    width="126"
                    height="12"
                    rx="6"
                    fill="var(--et-colors-card-text)"
                    fill-opacity="0.15"
                />
                <text
                    x="208"
                    y="183"
                    font-family="Inter"
                    font-weight="600"
                    font-size="14"
                    fill="var(--et-colors-card-text)"
                >
                    Can I return the purchased product?
                </text>
                <path
                    d="M618 174.5L624 180.5L630 174.5"
                    stroke="#667085"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <text
                    x="208"
                    y="254"
                    font-family="Inter"
                    font-weight="600"
                    font-size="14"
                    fill="var(--et-colors-card-text)"
                >
                    How do I get the source file?
                </text>
                <path
                    d="M618 246.5L624 252.5L630 246.5"
                    stroke="#667085"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <text
                    x="208"
                    y="326"
                    font-family="Inter"
                    font-weight="600"
                    font-size="14"
                    fill="var(--et-colors-card-text)"
                >
                    Where I can get help?
                </text>
                <path
                    d="M618 318.5L624 324.5L630 318.5"
                    stroke="#667085"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <rect x="184" y="141.5" width="476" height="1" fill="var(--et-colors-border)" />
                <rect x="184" y="213.5" width="476" height="1" fill="var(--et-colors-border)" />
                <rect x="184" y="285.5" width="476" height="1" fill="var(--et-colors-border)" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_414_3446">
                <rect
                    x="184"
                    y="6"
                    width="476"
                    height="351.5"
                    rx="12"
                    fill="var(--et-colors-card-background)"
                />
            </clipPath>
        </defs>
    </svg>
</template>
